module.exports = __webpack_public_path__ + "static/img/new_logo.24fac1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_logo.png
// module id = 01ue
// module chunks = 1